import 'phaser'
import { Game, GameState } from '../app/game'
import { Direction } from '../app/game'
import { RoadType } from './RoadPiece';
import App from '../main';
import { GAMEZOP_STATE, GameZopSDK } from '../app/libs/GameZopSDK';
import { GameConfig } from '../app/Utils';
// import { GC_MODES } from 'pixi.js';
export default class Car {

    private game;

    private inputKey;

    public carSprite: Phaser.Physics.Matter.Sprite;

    public currentDirection: Direction;
    targetDirection: number;
    private gameTargetDirection: number = 0;

    private currentSpeed: number = 14;
    public get CurrentSpeed(): number {
        return this.currentSpeed;
    }
    public set CurrentSpeed(value: number) {
        this.currentSpeed = value;
    }
    private carSpeed: number = 15.5;
    public get CarSpeed(): number {
        return this.carSpeed;
    }
    public set CarSpeed(value: number) {
        this.carSpeed = value;
    }

    private rotationAngle = 0;
    private revolutionAngle;

    private firstPress: boolean;
    private keyDown: boolean;
    private touchDown: boolean;

    private line: Phaser.GameObjects.Graphics;

    courseCorrectTween: any;
    drifting: boolean = false;
    carGliding: boolean = false;
    angleToCover: number = 0;

    angleLeftToDrift: number = 0;
    updatesToRunAfterDrift: number = 0;

    rotationAngleAdded: number = 0;
    public canCourseCorrect: boolean = false;

    lastCPDirection: number = 0;

    levelData: any;
    currentLevel: number = 0;

    perfectCounter: number = 0;

    driftMarks: Phaser.GameObjects.RenderTexture[];
    currentDriftMark = 0;
    trails: Phaser.GameObjects.Sprite[];

    radius: number;

    initialPos: any;

    frameNo: number = 0;

    public currentFps: number = 0;
    public turnCount: number = 0;

    smokeEmitter: Phaser.GameObjects.Particles.ParticleEmitter;
    smokeParticleMinSpeed: number = 50;
    smokeParticleMaxSpeed: number = 100;


    fireParticle: Phaser.GameObjects.Particles.ParticleEmitter;

    latch: Phaser.Sound.HTML5AudioSound;
    crash: Phaser.Sound.HTML5AudioSound;
    drift: Phaser.Sound.HTML5AudioSound;
    BGM: Phaser.Sound.BaseSound;

    constructor(scene: Phaser.Scene, x: number, y: number, key: string) {
        this.game = scene;

        this.initialPos = { x: x, y: y }
        this.levelData = App.levelData;
        this.turnCount += this.levelData.LevelData.LevelTurnCount[this.currentLevel];

        //var colliders = this.game.cache.json.get('colliders');
        this.carSprite = scene.matter.add.sprite(x, y, key);
        this.carSprite.setScale(0.5)
        this.carSprite.setTexture('carSpriteSheet', this.frameNo);
        this.carSprite.setRectangle(25, 60, {})
        this.carSprite.depth = 5;

        this.carSprite.setCollisionCategory(Game.enableCollisionLayer)
        this.carSprite.setCollidesWith([Game.enableCollisionLayer]);

        if(App.gamezopSDK.isKia() && !App.gamezopSDK.isBattleGame()){
            this.inputKey = this.game.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
        }
        else{
            this.inputKey = this.game.input.keyboard.removeKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
        }

        this.setTouchEvent();

        this.game.cameras.main.startFollow(this.carSprite, false, .41, .41);

        this.game.events.on('restart', () => { this.Restart() });
        this.game.events.on('gameover', () => { this.OnGameOver() });
        this.game.events.on('respawn', () => { this.Respawn() });

        this.game.scene.get('ui').events.on('pause', () => { this.PauseCar() });
        // this.game.scene.get('ui').events.on('restart', () => { this.Restart() });
        this.game.scene.get('ui').events.on('resume', () => { this.ResumeFromPause() });

        //sling line
        this.line = this.game.add.graphics();
        this.line.depth = 3;

        //drift marks
        this.trails = new Array();
        this.driftMarks = new Array();

        for (let i = 0; i < 3; i++) {
            this.driftMarks[i] = this.game.add.renderTexture(0, 0, App.MAX_WIDTH, App.MAX_HEIGHT)
        }

        for (let i = 0; i < 2; i++) {
            this.trails[i] = this.game.add.sprite(0, 0, 'spritesAtlaas', 'trail.png')
            this.trails[i].setVisible(false)
            this.trails[i].setScale(0.75)
        }

        //smoke
        var particles = this.game.add.particles('smoke');
        particles.depth = 3;
        this.smokeEmitter = particles.createEmitter({
            x: 500,
            y: 500,
            lifespan: 600,
            speed: { min: this.smokeParticleMinSpeed, max: this.smokeParticleMaxSpeed },
            angle: { min: this.carSprite.angle + 90 - 55, max: this.carSprite.angle + 90 + 55 },
            scale: { start: 0.0, end: 2 },
            alpha: { start: 0.30, end: 0 },
            frequency: 80,
            blendMode: 'ADD'
        });
        this.smokeEmitter.stop();

        //Fire
        var particles = this.game.add.particles('Fire');
        particles.depth = 3;
        this.fireParticle = particles.createEmitter({
            x: 500,
            y: 500,
            lifespan: 1000,
            speed: { min: 10, max: 20 },
            // angle: { min: this.carSprite.angle + 90 - 55, max: this.carSprite.angle + 90 + 55 },
            scale: { start: 0.02, end: 0.1 },
            alpha: { start: 0.2, end: 0 },
            frequency: 20,
            blendMode: 'ADD'
        });
        this.fireParticle.stop();


        //audio
        this.latch = this.game.sound.add('latch');
        this.crash = this.game.sound.add('crash');
        this.drift = this.game.sound.add('drift');
        this.BGM = this.game.sound.add('bgm');
        this.BGM.volume = 0.25;
        this.BGM.loop = true;
        this.game.events.once('onGameStart', this.onGameStart, this);
    }


    setTouchEvent() {

        this.game.input.on('pointerdown', () => {
            this.touchDown = true;
        });
        this.game.input.on('pointerup', () => {
            this.touchDown = false;
        });

    }

    onGameStart() {
        this.carSpeed = this.currentSpeed = this.levelData.LevelData.Speed[this.currentLevel] * this.currentFps;
        this.game.BeginGame();
        this.smokeEmitter.start();
        // this.BGM.stop();
        if (Game.bgmOn) {
            // this.BGM.play();
            // this.BGM.volume = 0.25;
        }
        this.game.cameras.main.setLerp(0.15);
    }
    
    delayKeyboardInput() {
        Game.isInput = false;
        setInterval(() => {
            Game.isInput = true;
        }, 1000)
    }
    
    update(dt: number) {

        this.currentFps = (dt * 60) / 1000;
        
        if (Game.currentControlPoint.cpNumber == this.turnCount) {
            App.isLevelup = true;
        }
        
        if (Game.isInput == true) {
            if ((this.inputKey.isDown || this.touchDown) && Game.currentGameState == 0) {
                this.delayKeyboardInput();
                this.game.events.emit('onGameStart'); 
            }

            if ((this.inputKey.isDown) && Game.currentGameState == 2) {
                this.delayKeyboardInput();
                this.game.events.emit('onGameEndUI');
                // this.game.events.emit('restart');
            }

            if((this.inputKey.isDown)&& Game.currentGameState == 3){
                if(App.totalLives >=1){
                    this.delayKeyboardInput(); 
                    this.game.events.emit('continueRespawn');   
                }
            }
        }


        if (Game.currentGameState == 1) {
            // this.game.events.emit('onGameStart');
            let cpSprite = Game.currentControlPoint;

            //tutorial
            if (Game.firstTime && this.Distance(this.carSprite, cpSprite) < 250) {
                Game.firstTime = false;
                this.StopCar();
                this.smokeEmitter.pause();
                this.game.events.emit('tutorial')

                this.game.time.addEvent({
                    delay: 2200,
                    callback: () => {
                        this.ResumeCar();
                        this.smokeEmitter.resume();
                    },
                    callbackScope: this
                })
            }

            if (this.updatesToRunAfterDrift > 0) {
                this.rotationAngle += (this.currentSpeed / this.radius * 67 * Game.currentControlPoint.rotationDirection);
                this.carSprite.angle = this.rotationAngle;

                this.updatesToRunAfterDrift--;
                if (this.updatesToRunAfterDrift <= 0) {
                    Game.CouseCorrect();
                }
            }

            //Count updates inside cp zone when not latched
            if (Game.currentControlPoint.canLatch && !(this.inputKey.isDown || this.touchDown)) {
                this.angleToCover += this.currentSpeed / 3
            }

            if ((this.inputKey.isDown || this.touchDown) && Game.currentControlPoint.canLatch) {
                
                this.targetDirection = this.gameTargetDirection;
                this.StopCourseCorrectTween();
                this.keyDown = true;
                Game.onInputDown();
                this.lastCPDirection = Game.currentControlPoint.rotationDirection;
                if (this.firstPress) {
                    this.firstPress = false;
                    this.radius = this.Distance(this.carSprite, cpSprite);
                    this.revolutionAngle = Math.atan2(this.carSprite.y - cpSprite.y, this.carSprite.x - cpSprite.x)
                    this.rotationAngle = this.carSprite.angle;
                    let angleToAdd = (this.currentSpeed / this.radius * 67 + (this.angleToCover * 0.3));
                    this.rotationAngle += (angleToAdd * Game.currentControlPoint.rotationDirection);
                    this.rotationAngleAdded += angleToAdd;
                    this.angleToCover -= this.angleToCover * 0.3;
                }

                //Factor - when input is given after sometime inside range, extra turning is required to compensate; Change it's values based on speed
                //Car rotation     
                let angleAdded = ((this.currentSpeed / this.radius * 67 /* *1.075*/) + (this.angleToCover * 0.2));
                this.rotationAngle += (angleAdded * Game.currentControlPoint.rotationDirection);
                this.rotationAngleAdded += angleAdded;
                this.angleToCover -= this.angleToCover * 0.2;
                this.carSprite.angle = this.rotationAngle;
                this.SetCarSprite();
                this.smokeEmitter.frequency = 20;
                this.smokeEmitter.setLifespan(2000);
                this.smokeParticleMinSpeed = 300;
                this.smokeParticleMaxSpeed = 350;

                // Move along circular path
                let driftMarksAngle = this.revolutionAngle - (0.08 * Game.currentControlPoint.rotationDirection);
                let angleToAdd = this.currentSpeed / this.radius * Game.currentControlPoint.rotationDirection
                this.revolutionAngle += angleToAdd;
                this.carSprite.x = cpSprite.x + (this.radius * Math.cos(this.revolutionAngle));
                this.carSprite.y = cpSprite.y + (this.radius * Math.sin(this.revolutionAngle));

                //drift marks
                let width = this.carSprite.width / 10;

                for (let i = 0; i < 3; i++) {
                    driftMarksAngle += angleToAdd / 3;
                    let driftRadius = this.radius + 8;

                    let x1 = cpSprite.x + ((driftRadius + width) * Math.cos(driftMarksAngle));
                    let y1 = cpSprite.y + ((driftRadius + width) * Math.sin(driftMarksAngle));
                    let x2 = cpSprite.x + ((driftRadius - width) * Math.cos(driftMarksAngle));
                    let y2 = cpSprite.y + ((driftRadius - width) * Math.sin(driftMarksAngle));
                    this.DrawDriftMarks(x1, y1, x2, y2);

                }

                this.heldDown++;
                if (this.heldDown > 8 && !this.driftAudioPlaying && Game.sfxOn) {
                    this.driftAudioPlaying = true;
                    this.drift.play();
                }
            }
            else {
                if(this.inputKey.isDown){App.gamezopSDK.onKeyInput();}
                if(this.touchDown){App.gamezopSDK.onTouchInput();} 
                this.smokeEmitter.frequency = 80;
                this.smokeEmitter.setLifespan(600);
                this.smokeParticleMinSpeed = 50;
                this.smokeParticleMaxSpeed = 100
                //key up
                if (this.keyDown) {
                    this.ResetValuesOnTouchUp();
                    if (!this.canCourseCorrect)
                        this.CheckCourseCorrect(this.rotationAngleAdded);
                    if (this.canCourseCorrect) {
                        this.updatesToRunAfterDrift = 1;
                        if (this.angleLeftToDrift > 5) {
                            this.updatesToRunAfterDrift = Math.floor(this.angleLeftToDrift / 3);
                        }
                    }
                }

                //move forward
                let angle;
                angle = (this.carSprite.angle - 90)

                if (this.carGliding || this.drifting) {
                    angle = this.targetDirection - 90;
                }

                if (!this.carGliding) {
                    if (this.currentSpeed > this.carSpeed) {
                        this.currentSpeed = Phaser.Math.Clamp(this.currentSpeed - 0.075, this.carSpeed, this.currentSpeed);
                    }
                    else {
                        this.currentSpeed = Phaser.Math.Clamp(this.currentSpeed + 0.075, this.currentSpeed, this.carSpeed);
                    }
                }

                this.carSprite.x = this.carSprite.x + (this.currentSpeed * Math.cos(angle / 57.3));
                this.carSprite.y = this.carSprite.y + (this.currentSpeed * Math.sin(angle / 57.3));

                this.firstPress = true;
            }

            //Draw line
            if ((this.inputKey.isDown || this.touchDown) && this.Distance(this.carSprite, cpSprite) < 250) {
                if (this.yetToLatch && Game.sfxOn) {
                    this.latch.play();
                    this.yetToLatch = false;
                    Game.currentControlPoint.Scale(true);
                }
                this.DrawLine(this.carSprite, cpSprite)
            } else {
                this.yetToLatch = true;
                Game.currentControlPoint.Scale(false);
                this.line.clear();
            }
            this.smokeEmitter.setPosition(this.carSprite.x, this.carSprite.y);
            this.fireParticle.setPosition(this.carSprite.x, this.carSprite.y);
            this.smokeEmitter.setAngle([this.carSprite.angle + 90 - 25, this.carSprite.angle + 90, this.carSprite.angle + 90 + 25])
        } else {
            //  this.OnGameOver();
        }

    }

    yetToLatch: boolean = true;
    driftAudioPlaying: boolean = false;
    heldDown: number = 0;

    ResetValuesOnTouchUp() {
        this.driftAudioPlaying = false;
        this.heldDown = 0
        this.drift.stop();

        this.keyDown = false;
        Game.onInputUp();
        this.angleToCover = 0;
        this.driftAlpha = 0;

    }

    OnGameOver() {
        //game over
        // this.Crash();
        Game.currentGameState = GameState.Gameover;
        // console.log("Game Over");
    }

    Crash() {
        this.fireParticle.visible = true;
        this.fireParticle.start();
        this.smokeEmitter.stop();
        this.currentSpeed = 0;
        if (Game.sfxOn) {
            // console.log("Crash sound");
            this.crash.play();
        }
        this.carSprite.setTint(0x607D8B)
        this.StopCourseCorrectTween();
    }
    value: number = 0;


    CourseCorrect() {

        this.rotationAngleAdded = 0;
        if (Math.abs(this.carSprite.angle - this.targetDirection) > 90) {
            this.targetDirection -= 360;
        }

        this.courseCorrectTween = this.game.tweens.add({
            targets: this.carSprite,
            angle: this.targetDirection,
            duration: this.levelData.LevelData.CourseCorrectDuration[this.currentLevel],
            delay: 70,
            ease: Phaser.Math.Easing.Back.Out,
            easeParams: [3.25]
        })

        this.canCourseCorrect = false;

        this.game.time.addEvent({
            delay: this.angleLeftToDrift,
            callback: () => {
                this.drifting = false;
            },
            callbackScope: this
        })
    }
    carGlideTimer: any;
    CarSpeedUp(x: number, y: number) {
        this.StopCourseCorrectTween();
        this.carGliding = true;
        if (this.targetDirection == 0 || this.targetDirection == -180 || this.targetDirection == 180) {
            this.game.tweens.add({
                targets: this.carSprite,
                x: x,
                duration: 500
            })
        } else {
            this.game.tweens.add({
                targets: this.carSprite,
                y: y,
                duration: 500
            })
        }

        this.carSprite.angle = this.targetDirection;
        this.currentSpeed = 20 * this.currentFps;

        this.game.time.addEvent({
            delay: 1000,
            callback: () => {
                this.currentSpeed = this.carSpeed;
                this.carGliding = false;
            },
            callbackScope: this
        })
    }

    LevelUp() {
        if (this.currentLevel < this.levelData.LevelData.LevelTurnCount.length - 1) {
            this.currentLevel++;
            // console.log("Current Level", this.currentLevel);
            // this.carSpeed = this.currentSpeed = this.levelData.LevelData.Speed[this.currentLevel] * this.currentFps;
        }
        this.turnCount += this.levelData.LevelData.LevelTurnCount[this.currentLevel];
    }

    driftAlpha: number = 0;

    DrawDriftMarks(x1: number, y1: number, x2: number, y2: number) {

        let driftMark = this.driftMarks[this.currentDriftMark];
        this.trails[0].setPosition(x1 - driftMark.x, y1 - driftMark.y);
        this.trails[1].setPosition(x2 - driftMark.x, y2 - driftMark.y);

        for (let i = 0; i < 2; i++) {
            this.trails[i].angle = this.carSprite.angle;
            this.trails[i].setAlpha(this.driftAlpha);
        }
        this.driftAlpha += 0.0065
        driftMark.depth = 4;
        driftMark.draw([this.trails[0], this.trails[1]]);
    }

    CPinRange() {
        this.driftAlpha = 0;
        this.driftMarks[++this.currentDriftMark % 3].clear()
        this.currentDriftMark %= 3;
        this.driftMarks[this.currentDriftMark].setPosition(Game.currentControlPoint.text.x - App.MAX_WIDTH_HALF, Game.currentControlPoint.text.y - App.MAX_HEIGHT_HALF)
    }

    DrawLine(sprite1: Phaser.GameObjects.Image, sprite2: Phaser.GameObjects.Image) {
        this.line.clear();
        this.line.lineStyle(7.5, 0xe51e21, 1);
        this.line.lineBetween(sprite1.x, sprite1.y, sprite2.x, sprite2.y);
    }

    Distance(sprite1: Phaser.GameObjects.Image, sprite2: Phaser.GameObjects.Image): number {
        let a = sprite1.x - sprite2.x;
        let b = sprite1.y - sprite2.y;
        return Math.sqrt(a * a + b * b)
    }

    DistanceBetweenCPandCar(): number {
        return this.Distance(this.carSprite, Game.currentControlPoint)
    }

    setDirection(dir: Direction) {

        this.currentDirection = dir;
        switch (dir) {
            case Direction.down: this.gameTargetDirection = 180; break;
            case Direction.up: this.gameTargetDirection = 0; break;
            case Direction.right: this.gameTargetDirection = 90; break;
            case Direction.left: this.gameTargetDirection = -90; break;
        }
    }

    getDirection(dir: Direction): number {

        let direction;
        switch (dir) {
            case Direction.down: direction = 180; break;
            case Direction.up: direction = 0; break;
            case Direction.right: direction = 90; break;
            case Direction.left: direction = -90; break;
        }
        return direction;
    }

    Normalize(x: number, y: number): Phaser.Math.Vector2 {
        let denominator = Math.sqrt((x * x) + (y * y));
        return new Phaser.Math.Vector2(x / denominator, y / denominator);
    }

    CheckCourseCorrect(rotationAngleAdded: number) {
        let minimum: number;
        let perfect: number;
        let perfectRange: number = this.levelData.LevelData.PerfectRange[this.currentLevel];

        switch (Game.currentControlPoint.road.roadType) {
            case RoadType.turn: minimum = 70; perfect = 90; this.angleLeftToDrift = 115 - rotationAngleAdded; break;
            case RoadType.uturn: minimum = 155; perfect = 180; this.angleLeftToDrift = 210 - rotationAngleAdded; break;
            case RoadType.loop: minimum = 240; perfect = 270; this.angleLeftToDrift = 295 - rotationAngleAdded; break;
        }

        if (rotationAngleAdded > minimum) {
            this.angleLeftToDrift = Phaser.Math.Clamp(this.angleLeftToDrift, 0, 25)
            this.drifting = true;
            this.canCourseCorrect = true;
            this.currentSpeed = this.carSpeed - 1.5;
        } else {
            this.canCourseCorrect = false;
        }

        if (this.rotationAngleAdded < (perfect + perfectRange) && this.rotationAngleAdded > (perfect - perfectRange)) {
            this.perfectCounter++;
            this.game.OnPerfectTurn(this.perfectCounter)
        } else {
            this.perfectCounter = 0;
        }
    }


    SetCarSprite() {
        let texture;

        if (this.carSprite.angle >= -45 && this.carSprite.angle < 45) {
            texture = 0
        }
        else if (this.carSprite.angle < -45 && this.carSprite.angle >= -135) {
            texture = 2
        }
        else if (this.carSprite.angle >= 45 && this.carSprite.angle < 135) {
            texture = 3
        }
        else {
            texture = 1;
        }
        if (this.frameNo != texture) {
            this.frameNo = texture;
            this.carSprite.setTexture('carSpriteSheet', texture)
        }
    }



    StopCourseCorrectTween() {
        if (this.courseCorrectTween)
            this.courseCorrectTween.stop();
    }

    ClearDriftMarks() {
        for (let i = 0; i < 3; i++) {
            this.driftMarks[i].clear()
        }
    }

    Restart() {
        this.fireParticle.visible = false;
        this.fireParticle.stop();
        this.ClearDriftMarks()
        // console.log("Restart Car script");
        this.turnCount = 0;
        this.game.events.once('onGameStart', this.onGameStart, this);
        Game.currentGameState = GameState.Menu;
        this.StopCourseCorrectTween()
        this.canCourseCorrect = false;
        this.carSprite.clearTint();
        this.game.cameras.main.setLerp(1)
        this.currentLevel = 0;
        this.carSprite.setPosition(this.initialPos.x, this.initialPos.y)
        this.angleToCover = this.rotationAngleAdded = this.angleLeftToDrift = 0;
        this.currentSpeed = this.carSpeed = this.levelData.LevelData.Speed[this.currentLevel] * this.currentFps;
        this.carSprite.angle = 0;
        this.touchDown = false;
        this.inputKey.isDown = false;
    }

    Respawn() {
        this.fireParticle.visible = false;
        this.fireParticle.stop();
        if (App.isLevelup && Game.currentControlPoint.cpNumber == this.turnCount + 1) {
            App.isLevelup = false;
            // this.game.levelUp();
            this.game.IncreaseStreakScore(19);
        }

        this.canCourseCorrect = false;

        let direction = Direction.up;
        let roadIndex = 1;

        this.ClearDriftMarks()
        this.line.clear()

        Game.currentControlPoint.Reset()

        this.currentSpeed = this.carSpeed = this.rotationAngleAdded = this.updatesToRunAfterDrift = this.angleLeftToDrift = 0;
        this.ResetValuesOnTouchUp();
        this.firstPress = true;

        if (Game.currentControlPoint.cpNumber > 1) {
            let cp = Game.mapGenerator.controlPoints[Game.currentControlPoint.cpNumber - 2];
            direction = cp.targetDirection;
            roadIndex = Game.mapGenerator.controlPoints[Game.currentControlPoint.cpNumber - 1].road.roadIndex - 1
        }

        this.carSprite.angle = this.getDirection(direction)
        let road = Game.mapGenerator.roadPieces[roadIndex];
        this.carSprite.setPosition(road.x, road.y);

        this.smokeEmitter.stop();

        this.carSprite.clearTint();

        this.game.time.addEvent({
            delay: 1500,
            callback: () => {
                Game.currentGameState = GameState.Game;
                this.ResumeCar();
            },
            callbackScope: this
        })

    }

    StopCar() {
        Game.currentGameState = GameState.Respawn;
        this.currentSpeed = this.carSpeed = 0;
        this.StopCourseCorrectTween();
    }

    PauseCar() {
        // this.ToggleBGM(false)
        this.game.scene.pause()
    }

    ResumeCar() {
        this.touchDown = false;
        this.inputKey.isDown = false;
        Game.currentGameState = GameState.Game;
        this.currentSpeed = this.carSpeed = this.levelData.LevelData.Speed[this.currentLevel] * this.currentFps;
        this.smokeEmitter.start()
    }

    ResumeFromPause() {
        this.touchDown = false;
        this.inputKey.isDown = false;
        // this.ToggleBGM(true)
    }

    ToggleBGM(bool: boolean) {
        if (bool) {
            if (this.BGM.isPaused)
                this.BGM.resume();
            else
                this.BGM.play()
        } else {
            this.BGM.pause();
        }
    }

}

